import { creators } from '@/mocks/videos';

export default function CreatorShowcase() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
            明星创作者
          </h2>
          <p className="text-sm text-foreground-500">
            与优秀创作者一起，发现无限精彩
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {creators.map((creator) => (
            <div
              key={creator.name}
              className="flex flex-col items-center p-5 rounded-xl bg-background-50 transition-all duration-300 hover:bg-background-200/70 cursor-pointer"
            >
              <img
                src={creator.avatar}
                alt={creator.name}
                className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover mb-3"
                loading="lazy"
              />
              <h4 className="font-heading text-sm text-foreground-900 mb-1 whitespace-nowrap">
                {creator.name}
              </h4>
              <p className="text-xs text-accent-600 font-medium mb-2 whitespace-nowrap">
                {(creator.followers / 10000).toFixed(0)}万粉丝
              </p>
              <p className="text-xs text-foreground-500 text-center leading-relaxed line-clamp-2">
                {creator.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}